import type { InjectionKey } from 'vue'

import type { APIKeysApi } from './apikeys-api'
import type { AuditApi } from './audit-api'
import type { AuthApi } from './auth-api'
import type { CarbonApi } from './carbon-api'
import type { OidcLauncher } from './oidc-launcher'
import type { ProviderKeysApi } from './provider-keys-api'
import type { RoutesApi } from './routes-api'
import type { RuntimeConfigApi } from './runtime-config-api'
import type { TeamsApi } from './teams-api'
import type { TenantsApi } from './tenants-api'
import type { UsersApi } from './users-api'

/**
 * Clés d'injection Vue typées pour les ports. Le composition root
 * (`infrastructure/bootstrap`) appelle `app.provide(KEY, adapter)` ; les
 * composables consomment via `inject(KEY)` avec typage strict.
 *
 * On garde les clés ici (pas dans le port lui-même) pour éviter une
 * dépendance vue dans `ports/auth-api.ts` qui doit rester pur.
 */
export const AUTH_API_KEY: InjectionKey<AuthApi> = Symbol('AuthApi')
export const OIDC_LAUNCHER_KEY: InjectionKey<OidcLauncher> = Symbol('OidcLauncher')
export const AUDIT_API_KEY: InjectionKey<AuditApi> = Symbol('AuditApi')
export const APIKEYS_API_KEY: InjectionKey<APIKeysApi> = Symbol('APIKeysApi')
export const TENANTS_API_KEY: InjectionKey<TenantsApi> = Symbol('TenantsApi')
export const USERS_API_KEY: InjectionKey<UsersApi> = Symbol('UsersApi')
export const TEAMS_API_KEY: InjectionKey<TeamsApi> = Symbol('TeamsApi')
export const ROUTES_API_KEY: InjectionKey<RoutesApi> = Symbol('RoutesApi')
export const PROVIDER_KEYS_API_KEY: InjectionKey<ProviderKeysApi> = Symbol('ProviderKeysApi')
export const RUNTIME_CONFIG_API_KEY: InjectionKey<RuntimeConfigApi> = Symbol('RuntimeConfigApi')
export const CARBON_API_KEY: InjectionKey<CarbonApi> = Symbol('CarbonApi')
